const e=t=>{if(0===t.subcategories.length)return t.level;const r=t.subcategories.map((t=>e(t)));return Math.max(t.level,...r)};export{e as findMaxLevel};
